import { render } from "./Attributes.vue?vue&type=template&id=4424f3d1&scoped=true"
import script from "./Attributes.vue?vue&type=script&lang=js"
export * from "./Attributes.vue?vue&type=script&lang=js"

import "./Attributes.vue?vue&type=style&index=0&id=4424f3d1&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4424f3d1"]])

export default __exports__